import { render, staticRenderFns } from "./Login_test.vue?vue&type=template&id=56a67d4e&"
import script from "./Login_test.vue?vue&type=script&lang=js&"
export * from "./Login_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports